import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { userCreate } from "../../../attendance-local-user-create";

export type CreateAttendanceUsersParams = {
    cpf_user: string;
    unidade: string;
    setor_id?: number;
    misto?: boolean;
};

export function useAttendanceLocalUserCreate() {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationKey: ["attendance-local", "user", "create"],
        mutationFn: async (params: CreateAttendanceUsersParams) =>
            userCreate(params),
        onSuccess: async () => {
            toast.success("Usuário adicionado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "user", "list"],
            });
        },
        onError: (error) => {
            toast.error("Algo deu errado, tente novamente!");
            console.log(error);
        },
    });

    return mutation;
}
